/**
 * Configuration centralisée - URL de base des API
 * Définir REACT_APP_API_URL dans .env (ex: https://api.vetlink.fr ou /api)
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || '/api';
